import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed } from "vue";
import filters from "@/core/helpers/filters";
import { CurrencyTypes } from "@/core/types/CurrencyTypes";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'BalanceShow',
  props: {
    balance: { default: 0 },
    currencyId: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const language = useStore().state.AuthModule.user.language;


const currencyShow = computed(() =>
  filters.toCurrency(props.balance, props.currencyId, language)
);

const balanceOnly = computed(() => {
  if (props.balance === null || props.balance === undefined) {
    return "0.00";
  }
  return (props.balance / 100).toFixed(2);
});

return (_ctx: any,_cache: any) => {
  return (props.currencyId && props.currencyId != -1)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(currencyShow.value), 1))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(balanceOnly.value), 1))
}
}

})